import { render, staticRenderFns } from "./rulePreviewDialog.vue?vue&type=template&id=2dff3d20"
import script from "./rulePreviewDialog.vue?vue&type=script&lang=js"
export * from "./rulePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./rulePreviewDialog.vue?vue&type=style&index=0&id=2dff3d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports